export class ResponseModel {
    message: string;
    constructor() {
    }
}
